var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-progress-circular',_vm._g(_vm._b({attrs:{"indeterminate":_vm.loading}},'v-progress-circular',[_vm.loadingDefaults, _vm.$attrs],false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }